define('common/ko/extension/field',['knockout', 'underscore'], function(ko, _) {

    //Extends an observable with functionality good for html-fields like input, text areas etc.
    ko.extenders.field = function(target, option) {
        option = _.extend({ focus: true, disable: true, selectText: true}, option);

        if(option.focus)  {
            target.focused = ko.observable(false);
        }

        if(option.disable) {
            target.disabled = ko.observable(false);
        }

        if(option.selectText) {
            target.textSelected = ko.observable(false);
            target.selectText = function() {
                target.textSelected(true);
            };
        }

        //return the original observable
        return target;
    };
});

